export default {
  atsTip: {
    passingCopy: {
      default:
        "You've added a company name ({companyName}) and web address ({jobUrl}) which can help us provide you ATS-specific tips.",
    },
    failingCopy: {
      default:
        "Adding this job's company name and web address can help us provide you ATS-specific tips.",
    },
    title: 'ATS tip',
    groupTitle: 'ATS tip',
    label: 'Company information',
  },
  jobTitleMatch: {
    passingCopy: {
      default:
        "The job title {jdJobTitle}, from the job description is also found in your resume. We recommend this to be the case to ensure you're found when recruiters search by job title.",
    },
    failingCopy: {
      default:
        "The {jdJobTitle} job title provided or found in the job description was not found in your resume. We recommend having the exact title of the job for which you're applying in your resume. This ensures you'll be found when a recruiter searches by job title. If you haven't held this position before, include it as part of your summary statement.",
    },
    title: 'Job title match',
    groupTitle: 'Job title match',
    label: 'Job title',
  },
  educationMatch: {
    passingCopy: {
      default:
        'This job requires or prefers a degree that was found in your resume.',
      // TODO: delete the following messages when legacy scan is gone
      degreeFound:
        'This job requires or prefers a {requiredEducation} degree. A {userEducation} degree was found in your resume.',
      noDegreeRequired: "This job doesn't specify a preferred degree.",
      // PE 3
      EducationInResumeFoundWhenNotRequiredAndPreferred:
        'The job description does not list required or preferred education, but your education is noted.',
      MatchedAllRequiredAndPreferred:
        'Your education matches both the required and preferred education listed in the job description.',
      MatchedRequiredNotPreferred:
        'Your education matches the required ({requiredEducation}) but not the preferred ({preferredEducation}) education listed in the job description.',
      MatchedRequiredWhenPreferredNotDefined:
        'Your education matches the required ({requiredEducation}) education listed in the job description.',
      MatchedPreferredWhenRequiredNotDefined:
        'Your education matches the preferred ({preferredEducation}) education listed in the job description.',
    },
    failingCopy: {
      default:
        'This job requires or prefers a {requiredEducation} degree. A matching {requiredEducation} degree was not identified on your resume. Be sure to also include its most common abbreviation (eg. PhD, JD, LLM).',
      // TODO: delete the following message when legacy scan is gone
      preferredDegreeNotMatched:
        'This job specifies a preferred degree that was not found in your resume.',
      // PE 3
      NoData:
        'The job description does not list required or preferred education, and your education information is missing.',
      MatchedPreferredNotRequired:
        'Your education matches the preferred ({preferredEducation}) but not the required ({requiredEducation}) education listed in the job description. Explain how your experience compensates for the required education in your application.',
      DidNotMatchBothRequiredAndPreferred:
        'Your education does not match the required ({requiredEducation}) or preferred ({preferredEducation}) education listed in the job description. If your experience is strong, consider explaining this in your summary or cover letter.',
      DidNotMatchRequiredWhenPreferredNotDefined:
        'Your education does not match the required ({requiredEducation}) education listed in the job description. If your experience is strong, consider explaining this in your summary or cover letter.',
      DidNotMatchPreferredWhenRequiredNotDefined:
        'Your education does not match the preferred ({preferredEducation}) education listed in the job description. If your experience is strong, consider explaining this in your summary or cover letter.',
    },
    title: 'Education match',
    groupTitle: 'Education match',
    label: 'Education',
  },
  sectionHeadings: {
    title: 'Section headings',
  },
  headingWork: {
    passingCopy: {
      default: 'We found the work experience section in your resume.',
    },
    failingCopy: {
      default:
        'Name your experience section “Work History" or “Professional Experience” for ATS to recognize work sections.',
    },
    title: 'Work experience',
    groupTitle: 'Section headings',
    label: 'Work experience',
  },
  workHistory: {
    passingCopy: {
      default: '',
    },
    failingCopy: {
      default:
        'Your Work Experience section appears empty. We recommend that this section should showcase at least one listing, even if it is just an internship or a personal project.',
    },
    title: 'Work section completeness',
    groupTitle: 'Section headings',
    label: 'Work section completeness',
  },
  headingObjective: {
    passingCopy: {
      default: '',
    },
    failingCopy: {
      default:
        'Objectives are not necessary in today’s job market. Use a brief summary instead.',
    },
    title: 'Objective Section',
    groupTitle: 'Section headings',
    label: 'Objective statement',
  },
  headingEducation: {
    passingCopy: {
      default: 'We found the education section in your resume.',
    },
    failingCopy: {
      default:
        'We couldn\t find an "Education" section in your resume. Ensure your resume includes an education section labeled as "Education" to ensure ATS can accurately recognize your academic qualifications.',
    },
    title: 'Education Section',
    groupTitle: 'Section headings',
    label: 'Education',
  },
  dateFormatting: {
    passingCopy: {
      default:
        'The dates in your work experience section are properly formatted.',
    },
    failingCopy: {
      default:
        'ATS and recruiters prefer specific date formatting for your work experience. Please use the following formats: “MM/YY or MM/YYYY or Month YYYY” (e.g. 03/19, 03/2019, Mar 2019 or March 2019). We suggest updating these dates:',
      noDates: 'No dates were found within the text of your resume.',
    },
    title: 'Date formatting',
    groupTitle: 'Date formatting',
    label: 'Date formatting',
  },
  contactInfo: {
    title: 'Contact info',
  },
  contactPhone: {
    description:
      'Provide your phone number to make it easy for employers to reach you.',
    passingCopy: {
      default: 'You provided your phone number.',
    },
    failingCopy: {
      default:
        'We did not find a phone number in your resume. Some recruiters prefer a phone call to email.',
      docxRequired:
        'Please upload a .docx resume in order to view this finding',
    },
    title: 'Contact info',
    groupTitle: 'Contact info',
    label: 'Phone number',
  },
  contactEmail: {
    description:
      'Provide your email address to allow employers to reach you online.',
    passingCopy: {
      default: 'You provided your email.',
    },
    failingCopy: {
      default:
        'We did not find an email in your resume. Add an email so that recruiters has a means to contact you.',
      docxRequired:
        'Please upload a .docx resume in order to view this finding',
    },
    title: 'Contact info',
    groupTitle: 'Contact info',
    label: 'Email',
  },
  contactAddress: {
    description:
      'Provide your address to allow employers to confirm your location.',
    passingCopy: {
      default: 'You provided your physical address.',
    },
    failingCopy: {
      default:
        'We did not find an address in your resume. Recruiters use your address to validate your location for job matches.',
      docxRequired:
        'Please upload a .docx resume in order to view this finding',
    },
    title: 'Contact info',
    groupTitle: 'Contact info',
    label: 'Address',
  },
  fileType: {
    title: 'File type',
  },
  fileFormat: {
    passingCopy: {
      default:
        'DOCX, DOC, or PDF formats are preferred formats for most ATS parsers.',
      docxFormat:
        'DOCX, DOC, or PDF formats are preferred formats for most ATS parsers.',
      pdfFormat:
        'DOCX, DOC, or PDF formats are preferred formats for most ATS parsers.',
    },
    failingCopy: {
      default:
        "DOCX, DOC, or PDF formats are preferred formats for most ATS parsers. Consider converting your resume to one of these formats to ensure it's parsed correctly.",
    },
    title: 'File type',
    groupTitle: 'File',
    label: 'File type',
  },
  fileNameCharacters: {
    passingCopy: {
      default:
        "Your file name doesn't contain special characters that could cause an error in ATS.",
    },
    failingCopy: {
      default:
        'Remove spaces or the following characters from your file name. These characters can cause errors in some ATS.',
    },
    title: 'File Name Characters',
    groupTitle: 'File',
    label: 'File name characters',
  },
  fileNameLength: {
    passingCopy: {
      default: 'Your file name is concise and readable.',
    },
    failingCopy: {
      default:
        'Your file name length is above the 30 character limit we recommend.',
    },
    title: 'File Name Length',
    groupTitle: 'File',
    label: 'File name length',
  },
  wordCount: {
    passingCopy: {
      default: 'Your resume is the correct length.',
      australia:
        'There are {wordCount} words in your resume and Australia-based jobs consider it the norm to have longer than 1000 word count.',
      nonAustralia:
        'There are {wordCount} words in your resume, which is under the suggested 1000 word count for relevance and ease of reading reasons.',
    },
    failingCopy: {
      default:
        'There are {wordCount} words in your resume.  If you are not applying to executive-level, government, or Australia-based jobs, consider reducing your resume length to under 1000 words to increase focus and for ease of reading by recruiters.',
      nonAustralia:
        'There are {wordCount} words in your resume.  If you are not applying to executive-level, government, or Australia-based jobs, consider reducing your resume length to under 1000 words to increase focus and for ease of reading by recruiters.',
      australia:
        'There are {wordCount} words in your resume.  If you are not applying to executive-level, government, or Australia-based jobs, consider reducing your resume length to under 1000 words to increase focus and for ease of reading by recruiters.',
    },
    title: 'Word count',
    groupTitle: 'Word count',
    label: 'Word count',
  },
  measurableResults: {
    passingCopy: {
      default:
        'There are five or more mentions of measurable results in your resume. Keep it up - employers like to see the impact and results that you had on the job.',
    },
    failingCopy: {
      default:
        'We found {measurableResultsCount} mentions of measurable results in your resume. Consider adding at least 5 specific achievements or impact you had in your job (e.g. time saved, increase in sales, etc).',
    },
    title: 'Measurable results',
    groupTitle: 'Measurable results',
    label: 'Measurable results',
  },
  gpa: {
    passingCopy: {
      default: 'Kudos for the recent good grades!',
    },
    failingCopy: {
      default:
        "Remove your GPA if it’s less than 3.5 and you've been more than 10 years out of school.",
    },
    title: 'GPA',
    groupTitle: 'GPA',
    label: 'GPA',
  },
  jobLevelMatch: {
    passingCopy: {
      default:
        "Your years of experience align with the role's requirements. This is a positive start, but remember to carefully review all other job criteria to ensure you're a strong overall match before applying.",
    },
    failingCopy: {
      default:
        "Your experience is less than the role requires. If you're confident you can perform the job and meet other criteria, consider applying. Include a strong summary explaining why you're a great fit despite having fewer years of experience. Be aware that experience is often an initial screening factor.",
      noJdRequirement:
        "No specific years of experience were found in this job description. Focus on matching your skills and qualifications to the role's requirements. Consider how your experience, regardless of duration, aligns with the job's key responsibilities before applying.",
      overQualified:
        "You have more years of experience than the role requires. Keep in mind that our assessment considers total experience, not just relevant years. If you're changing fields or have specific reasons for pursuing this role, consider adding a brief explanation in your application to provide context.",
    },

    title: 'Job level match',
    groupTitle: 'Job level match',
    label: 'Job level match',
  },
  resumeTone: {
    passingCopy: {
      default:
        'The tone of your resume is generally positive and no common cliches and buzzwords were found. Good job!',
    },
    failingCopy: {
      default: "We've found some negative phrases or cliches in your resume",
      negativeWords:
        "We've found some negative phrases or cliches in your resume:",
      negativeSentiment:
        'The tone of your resume is generally negative. Please consider using more positive words to reinforce your achievements.',
    },
    title: 'Words to avoid',
    groupTitle: 'Words to avoid',
    label: 'Words to avoid',
  },
  references: {
    passingCopy: {
      default:
        '"References available upon request” was not found in your resume',
    },
    failingCopy: {
      default:
        '"References available upon request” is not necessary on your resume. Recruiters assume you have references and will ask for them during the interview process. Use this space for additional skills or work history.',
    },
    title: 'References',
    groupTitle: 'References',
    label: 'References',
  },
  webPresence: {
    passingCopy: {
      default:
        "Nice - You've linked to a website that builds your web credibility. Recruiters appreciate the convenience and credibility associated with a professional website.",
    },
    failingCopy: {
      default:
        'Consider adding a website or Linkedin url to build your web credibility. Recruiters appreciate the convenience and credibility associated with a professional website.',
    },
    description:
      'Linking to a website builds your web credibility. Recruiters appreciate the convenience and credibility associated with a professional website.',
    title: 'Web presence',
    groupTitle: 'Web presence',
    label: 'Web presence',
  },
  industryDepth: {
    passingCopy: {
      default:
        'Your professional experience aligns very well with this position based on industry depth. Many recruiters recognize depth of expertise in a field as more important than having every skill on the job description.',
    },
    failingCopy: {
      default: '',
    },
    title: 'Industry depth',
    groupTitle: 'Industry depth',
    label: 'Industry depth',
  },
  industryBreadth: {
    passingCopy: {
      default:
        'Recruiters really appreciate candidates with breadth of skills in their industry. Although your experience with {extraSkillsArray}, etc., are not part of the job description, it will add bonus points to the hiring manager.',
    },
    failingCopy: {
      default: '',
    },
    title: 'Industry breadth',
    groupTitle: 'Industry breadth',
    label: 'Industry breadth',
  },
  fontCheck: {
    title: 'Font check',
    groupTitle: 'Formatting',
    label: 'Font check',
  },
  pageSetup: {
    title: 'Page setup',
    groupTitle: 'Formatting',
    label: 'Page setup',
  },
  layout: {
    title: 'Layout',
    groupTitle: 'Formatting',
    label: 'Layout',
  },
  fontSize: {
    description:
      'The average font size of your resume should meet readability and ATS standards. ',
    passingCopy: {
      default:
        'The average font size of your resume meets readability and ATS standards.',
    },
    failingCopy: {
      default: 'Your resume should use a standard font size.',
      fontSizeBelowMin:
        'The average font size of your resume is too small. Consider enlarging your font to increase readability.',
      fontSizeAboveMax:
        'The average font size of your resume is too large. Consider reducing your font size to increase content.',
      docxRequired:
        'Please upload a .docx resume in order to view this finding',
    },
    title: 'Font size',
    groupTitle: 'Font check',
    label: 'Font size',
  },
  fontCount: {
    description:
      'Your resume should contain only 1 or 2 font faces to maintain readability. ',
    passingCopy: {
      default: 'Your resume does not overuse different fonts.',
    },
    failingCopy: {
      default:
        'Your resume contains three or more different types of font faces. We recommend you keep the styling simple and consistent by using only 1 or 2 fonts.',
      docxRequired:
        'Please upload a .docx resume in order to view this finding',
    },
    title: 'Font count',
    groupTitle: 'Font check',
    label: 'Font count',
  },
  fontFamily: {
    description: 'Your resume should use a standard font face. ',
    passingCopy: {
      default: 'Your resume uses a standard font.',
    },
    failingCopy: {
      default:
        'Your resume contains {fontFamilyCount} non-standard font(s) ({fontFamilyArray}). We recommend standard fonts such as Arial, Times New Roman, or Helvetica for readability and ATS-compatibility.',
      docxRequired:
        'Please upload a .docx resume in order to view this finding',
    },
    title: 'Font Family',
    groupTitle: 'Font check',
    label: 'Font Family',
  },
  fontBold: {
    description:
      'We recommend using bold styling for job titles, company names, and your name to help improve readability. ',
    passingCopy: {
      default:
        'Your resume makes use of sparse bold styling. This increases readability for a recruiter.',
    },
    failingCopy: {
      default: 'Do not overuse or underuse bold font in your resume',
      fontBoldBelowMin:
        "Your resume doesn't contain enough bold styling. We recommend using bold styling for job titles, company names, and your name to help improve readability.",
      fontBoldAboveMax:
        'Your resume contains too much bold styling. We recommend only using bold styling for job titles, company names, and your name to help improve readability.',
      docxRequired:
        'Please upload a .docx resume in order to view this finding',
    },
    title: 'Bold Font',
    groupTitle: 'Font check',
    label: 'Bold Font',
  },
  fontColor: {
    description:
      'Ensure your resume text is a readable color, with adequate contrast to the document background. ',
    passingCopy: {
      default: 'Your font is in a readable color.',
    },
    failingCopy: {
      default:
        'Part of your resume is not in a color that’s easy to read. Use a black font to make sure important information is clear and easily readable.',
      docxRequired:
        'Please upload a .docx resume in order to view this finding',
    },
    title: 'Font color',
    groupTitle: 'Font check',
    label: 'Font color',
  },
  specialCharacters: {
    description:
      'Do not overuse special characters in your resume. These characters can cause errors in ATS and make your resume look less professional. ',
    passingCopy: {
      default: 'Special characters were not overused in your resume.',
    },
    failingCopy: {
      default:
        'Special characters are overused in your resume. These characters can cause errors in ATS and make your resume look less professional.',
      docxRequired:
        'Please upload a .docx resume in order to view this finding',
    },
    title: 'Special characters',
    groupTitle: 'Font check',
    label: 'Special characters',
  },
  pageSize: {
    description: 'Ensure that your resume document is an a standard size. ',
    passingCopy: {
      default: 'Your document page size is standard.',
    },
    failingCopy: {
      default:
        'Your document page size is not standard. This could cause a problem for recruiters who want to print off your resume for review.',
      docxRequired:
        'Please upload a .docx resume in order to view this finding',
    },
    title: 'Page size',
    groupTitle: 'Page setup',
    label: 'Page size',
  },
  pageMargins: {
    description:
      'The margins on your resume should be of a consistent and standard size. ',
    passingCopy: {
      default: 'Your margin sizes are all consistent and standard sizes.',
    },
    failingCopy: {
      default: 'Your resume should use standard and consistent margins.',
      marginMismatch:
        'Your left and right margins are different sizes. We recommend using margins of the same size for a professional, detail-oriented look.',
      marginBelowMin:
        'One or more of your margins are too small. We recommend margins between 0.5 and 1 inch for ease of reading.',
      marginAboveMax:
        'One or more of your margins are too big. We recommend margins between 0.5 and 1 inch for ease of reading.',
      docxRequired:
        'Please upload a .docx resume in order to view this finding',
    },
    title: 'Page margins',
    groupTitle: 'Page setup',
    label: 'Page margins',
  },
  pageHeaders: {
    description:
      'Avoid adding information to the header of your resume document. ',
    passingCopy: {
      default: 'Your resume does not contain information in headers.',
    },
    failingCopy: {
      default:
        'Your resume contains information in the header. Some ATS can’t accurately parse headers or footers, which could affect your formatting or searchability. Remove if possible.',
      docxRequired:
        'Please upload a .docx resume in order to view this finding',
    },
    title: 'Page headers',
    groupTitle: 'Page setup',
    label: 'Page headers',
  },
  pageFooters: {
    description:
      'Avoid adding information to the footer of your resume document. ',
    passingCopy: {
      default: 'Your resume does not contain information in footers.',
    },
    failingCopy: {
      default:
        'Your resume contains information in the footer. Some ATS can’t accurately parse headers or footers, which could affect your searchability. Remove if possible.',
      docxRequired:
        'Please upload a .docx resume in order to view this finding',
    },
    title: 'Page footers',
    groupTitle: 'Page setup',
    label: 'Page footers',
  },
  textAlignment: {
    description: 'Your resume text should be left aligned. ',
    passingCopy: {
      default:
        'Your resume primarily uses standardized left alignment for text sections.',
    },
    failingCopy: {
      default:
        'Your resume is not primarily left aligned. We recommend using left align for text sections as it enhances readability for a recruiter. Text justify is not recommended because some ATS’s can’t detect spaces between justified text blocks.',
      docxRequired:
        'Please upload a .docx resume in order to view this finding',
    },
    title: 'Text alignment',
    groupTitle: 'Layout',
    label: 'Text alignment',
  },
  tables: {
    description: 'Avoid using tables in your resume. ',
    passingCopy: {
      default: 'Your resume does not contain any tables.',
    },
    failingCopy: {
      default:
        'Your resume contains one or more tables with which can trip up some ATS. Text can be out of order or combined into one text blob. We recommend you avoid multiple column tables in your resume.',
      docxRequired:
        'Please upload a .docx resume in order to view this finding',
    },
    title: 'Tables',
    groupTitle: 'Layout',
    label: 'Tables',
  },
  images: {
    description: 'Avoid embedding images in your resume. ',
    passingCopy: {
      default: 'Your resume doesn’t contain images.',
    },
    failingCopy: {
      default:
        'Your resume contains images. Some ATS cannot read images and might cause formatting errors. If you’re applying to jobs within North America, consider removing photographs.',
      docxRequired:
        'Please upload a .docx resume in order to view this finding',
    },
    title: 'Images',
    groupTitle: 'Layout',
    label: 'Images',
  },
  columns: {
    description:
      'Avoid columns in your resume, as some ATS have trouble accurately parsing them. ',
    passingCopy: {
      default:
        'Your resume does not contain columns. Some ATS have trouble accurately parsing columns.',
    },
    failingCopy: {
      default:
        'Your resume contains columns. Some ATS can’t accurately parse columns, which could affect your formatting or searchability. Remove them if possible.',
      docxRequired:
        'Please upload a .docx resume in order to view this finding',
    },
    title: 'Columns',
    groupTitle: 'Layout',
    label: 'Columns',
  },
  paragraphLength: {
    description:
      'Keep your paragraphs concise and to the point for ease of readability. ',
    passingCopy: {
      default:
        'Your paragraphs are concise and to the point, which makes your resume easier for recruiters to read.',
    },
    failingCopy: {
      default:
        'Some of your paragraphs are longer than 40 words. Consider shortening them for readability to bring attention to your skills and accomplishments.',
      docxRequired:
        'Please upload a .docx resume in order to view this finding',
    },
    title: 'Paragraph length',
    groupTitle: 'Layout',
    label: 'Paragraph length',
  },
  summary: {
    passingCopy: {
      default:
        "We found a summary section on your resume. Good job! The summary provides a quick overview of the candidate's qualifications, helping recruiters and hiring managers promptly grasp the value the candidate can offer in the position.",
    },
    failingCopy: {
      default:
        "We did not find a summary section on your resume. The summary provides a quick overview of the candidate's qualifications, helping recruiters and hiring managers promptly grasp the value the candidate can offer in the position.",
    },
    groupTitle: 'Summary',
    title: 'Summary',
    label: 'Summary',
  },
}
